module.exports = __webpack_public_path__ + "img/energy_jiazhi.4f59082d.png";